module.exports = __webpack_public_path__ + "f6680566eee66c4f8748046c7618e12e.svg";